import React, { useState } from 'react';
import { CompetitionNavBtn } from '../CompetitionNavBtn/CompetitionNavBtn';
import { GeneralNavBtn } from '../GeneralNavBtn/GeneralNavBtn';
import { TrainingNavBtn } from '../TrainingNavBtn/TrainingNavBtn';
import GameModesCarousel from '../GameModesCarousel/GameModesCarousel';

const GameModesMobile: React.FC = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <>
      <GameModesCarousel setActiveSlide={setActiveSlide} />
      {activeSlide === 0 && <CompetitionNavBtn />}
      {activeSlide === 1 && <GeneralNavBtn />}
      {activeSlide === 2 && <TrainingNavBtn />}
    </>
  );
};

export default GameModesMobile;
